import { render, staticRenderFns } from "./bookRepositoryRmd.vue?vue&type=template&id=6044deab&scoped=true&"
import script from "./bookRepositoryRmd.vue?vue&type=script&lang=js&"
export * from "./bookRepositoryRmd.vue?vue&type=script&lang=js&"
import style0 from "./bookRepositoryRmd.vue?vue&type=style&index=0&id=6044deab&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6044deab",
  null
  
)

export default component.exports